module.exports = __webpack_public_path__ + "img/new-checkbox-on.af01fec3.svg";